import Vue from 'vue'

export default {
  namespaced: true,
  state: {
    tickers: {},
  },
  getters: {},
  mutations: {
    /* eslint no-param-reassign: "error" */
    /* eslint no-nested-ternary: 0 */

    UPDATE_TICKER: (state, payload) => {
      const previousTick = state.tickers[payload.symbol]

      // Adicionar direção da mudança de preço (para indicadores visuais)
      if (previousTick && previousTick.price) {
        const prevPrice = parseFloat(previousTick.price)
        const newPrice = parseFloat(payload.price)
        payload.pchg = newPrice > prevPrice ? 1 : newPrice < prevPrice ? -1 : 0
      } else {
        payload.pchg = 1 // Primeira vez, assumir positivo
      }

      // Manter timestamp de última atualização
      payload.lastUpdated = Date.now()

      Vue.set(state.tickers, payload.symbol, payload)
    },

    // Limpar ticker específico
    CLEAR_TICKER: (state, symbol) => {
      Vue.delete(state.tickers, symbol)
    },
  },
  actions: {
    // Atualizar ticker com dados do websocket
    updateTicket({ commit }, payload) {
      commit('UPDATE_TICKER', payload)
    },
  },
}
